export default __webpack_public_path__ + "media/images/call-3ffbb009cba8e415627562639a701155.svg";